export enum EVENT {
    PLAY = 'play',
    PING = 'ping',
    PAUSE = 'pauseStart',
    SESSION_START = 'sessionStart',
    SESSION_END = 'sessionEnd',
    SESSION_COMPLETE = 'sessionComplete',
}

export enum CONTENT_TYPE {
    LIVE = 'live',
    VOD = 'vod',
}

export interface GetVisitorIdParams {
    d_orgid: string
    d_ver: string
    d_mid?: string
    d_blob?: string
    dcs_region?: number
}

export interface ChannelAnalytics {
    mediaId: string
    mediaName: string
}

export interface GetVisitorIdResponse {
    d_mid: string
    id_sync_ttl: number
    d_blob: string
    dcs_region: number
    d_ottl: number
    ibs: []
    subdomain: string
    tid: string
}
